import React, {useEffect} from "react";
import {Box, Link, Typography, useMediaQuery} from "@mui/material";
import {useTranslation} from "react-i18next";

import LogoFooter from "./Icons/LogoFooter/index";
import HBC from "./Icons/HBC";
import theme from "./styles/theme/theme";
import {isRegion} from "../config";

const Footer = () => {
  const {t} = useTranslation();
  const [partnerLogo, setPartnerLogo] = React.useState(false);

  const isSmScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMdScreen = useMediaQuery(theme.breakpoints.up("sm"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
  const isXlScreen = useMediaQuery(theme.breakpoints.up("lg"));

  useEffect(() => {
    if (isRegion.romania) {
      setPartnerLogo(true);
    } else if (isRegion.latam) {
      setPartnerLogo(false);
    }
  }, []);

  let indentation;
  switch (true) {
    case partnerLogo && isXlScreen:
      indentation = 62;
      break;
    case partnerLogo && isMdScreen:
      indentation = 42;
      break;
    case partnerLogo && isSmScreen:
      indentation = 50;
      break;
    default:
      indentation = 100;
  }

  return (
    <Box
      sx={{
        display: "flex",
        textAlign: "left",
        flexDirection: `${isSmScreen ? "column" : "row"}`,
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: `35px ${isLargeScreen ? "70px" : "20px"}`,
        backgroundImage: `linear-gradient(${isSmScreen ? 180 : 120}deg, ${
          theme.palette.secondary["600"]
        } ${indentation}%, ${theme.palette.common.white} ${indentation}%)`,
      }}
    >
      <Box>
        <Link href="/" sx={{color: theme.palette.common.white}}>
          <LogoFooter
            width={`${!isSmScreen ? "180" : "90"}`}
            height={`${!isSmScreen ? "59" : "30"}`}
            color={theme.palette.common.white}
          />
        </Link>
        <Typography
          component="p"
          variant="body2"
          color={(theme) => theme.palette.common.white}
          marginTop="15px"
        >
          {t("common.powered_by")}{" "}
          <Typography component="span" fontWeight={600} marginLeft="5px">
            {t("common.steward_redqueen")}
          </Typography>
        </Typography>
      </Box>
      {partnerLogo && (
        <Box>
          <Link
            target="_blank"
            href="https://www.coca-colahellenic.com/"
            sx={{color: theme.palette.common.white}}
          >
            <HBC
              width={isSmScreen ? "178" : "356"}
              height={isSmScreen ? "27" : "55"}
            />
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default Footer;
